"use client"

import styled from "@emotion/styled"
import { useState } from "react"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import Form from "./Form"
import { FormObject } from "./Hero"
import ReactPlayerComponent from "./ReactPlayer"
import VideoControls from "./VideoControls"

const GradientOverlay = styled.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  ${({ theme }) => theme.breakpoints.down("md")} {
    height: 340px;
  }
  background: linear-gradient(
    270deg,
    rgba(0, 46, 33, 0) -17.63%,
    rgba(0, 46, 33, 0.72) 111.33%
  );
  pointer-events: none;
`

const GeneralLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const StyledLayout = styled.div`
  width: 100%;
  background-color: ${sharedColors.mediumGrayLight};
  padding: 24px 0;
  padding-bottom: 48px;
  position: relative;
  height: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: fit-content;
    min-height: 600px;
    padding: 64px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    min-height: 624px;
    padding: 88px 0;
  }
`
const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0;
    flex-direction: row;
  }
`

const StyledFormDiv = styled.div`
  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: 140px;
    z-index: 3;
  }
`

type Props = {
  source: string
  formObject: FormObject
}

export default function MediaHero({ source, formObject }: Props) {
  const [playing, setPlaying] = useState(true)
  const [volume, setVolume] = useState(false)
  return (
    <>
      <GeneralLayout>
        <StyledLayout>
          <Container>
            <StyledDiv>
              <VideoControls
                playing={playing}
                setPlaying={setPlaying}
                volume={volume}
                setVolume={setVolume}
              />
              <StyledFormDiv>
                <Form formObject={formObject} />
              </StyledFormDiv>
            </StyledDiv>
          </Container>

          <GradientOverlay />
          <ReactPlayerComponent
            source={source}
            playing={playing}
            setPlaying={setPlaying}
            volume={volume}
            setVolume={setVolume}
          />
        </StyledLayout>
      </GeneralLayout>
    </>
  )
}
